// extracted by mini-css-extract-plugin
export var firstLineThreeCol = "CYQyC";
export var firstLineThreeColDenseless = "khDwH";
export var full = "Ejrkd";
export var medium = "U2XB8";
export var mediumTypeRampUpdates = "L9Agk";
export var messageListMajorTextNext = "gy2aJ";
export var messageListMinorTextNext = "_rWRU";